import help2Style from "./help2.module.css"


export default function Help2(props) {

    const helpToggle = window.EventManager.helpToggle

    const on = props['on']
    const text = props['text']
    const reverse = props['reverse']

    return(
        helpToggle &&
        <div
            style={{
                display: on === true ? "flex" : "none",
                alignItems: "center",
                position: "absolute",
                left: "0px",
                top: "0px",
                width: "100%",
                height: "100%",
                pointerEvents: "none",
                zIndex: "100",
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    width: "100%",
                }}
            >
                <div
                    className={
                        help2Style['help']
                        + ' ' +
                        (reverse === true && help2Style['reverse'])
                    }
                    style={{
                        position: "absolute",
                        ...reverse === true && {
                            bottom: "100px",
                        }
                    }}
                >
                    <svg
                        width="48"
                        height="48"
                        viewBox="0 0 24 24"
                        fill="white"
                        stroke="red"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{
                            ...reverse === true && {
                                transform: "scaleY(-1)"
                            }
                        }}
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5" />
                        <path d="M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5" />
                        <path d="M14 10.5a1.5 1.5 0 0 1 3 0v1.5" />
                        <path d="M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47" />
                        <path d="M5 3l-1 -1" />
                        <path d="M4 7h-1" />
                        <path d="M14 3l1 -1" />
                        <path d="M15 6h1" />
                    </svg>
                </div>

                <div
                    style={{
                        position: "absolute",
                        color: "red",
                        bottom: "-130px",
                        ...reverse === true && {
                            bottom: "120px"
                        }
                    }}
                >{text}</div>
            </div>
        </div>
    )
}